import { resolvePath } from '@webapps/utils';
import PropTypes from 'prop-types';
import { useRef } from 'react';

import DatePicker from '../components/DatePicker';
// import TextField from '../components/TextField';
import { DateRange } from '@material-ui/icons';
import { InputAdornment } from '@material-ui/core';
import TextField50P from '../components/TextField50';
import TextFieldPx from '../components/TextFieldPx';
import { css } from '@emotion/css';

const FormikDatePicker = ({
  defaultValue = null,
  formik: { errors, setFieldValue, touched, values },
  fullWidth,
  label,
  name,
  pathValue,
  inputProps,
  InputProps,
  disabled,
  onDisabledClick,
  variant,
  borderRadius,
  onChange,
  ...props
}) => {
  const ref = useRef();

  return (
    <DatePicker
      label={label}
      disabled={disabled}
      onChange={onChange ? onChange : (value) => {
        setFieldValue(
          name,
          pathValue ? resolvePath(value, pathValue, false) : value,
          true
        );
      }}
      border
      PopoverProps={{
        anchorEl: () => ref.current,
      }}
      TextFieldComponent={({ onClick, value: newValue }) => (
        <TextFieldPx
          error={
            !!resolvePath(touched, name, '') && !!resolvePath(errors, name, '')
          }
          fullWidth={fullWidth}
          helperText={
            resolvePath(touched, name, '') && resolvePath(errors, name, '')
          }
          borderRadius={borderRadius}
          disabled={disabled}
          inputProps={inputProps}
          InputProps={InputProps}
          inputRef={ref}
          label={label}
          name={name}
          onClick={disabled ? onDisabledClick : onClick}
          value={newValue}
          variant={variant}
        />
      )}
      value={resolvePath(values, name, defaultValue)}
      {...props}
    />
  );
};

FormikDatePicker.propTypes = {
  name: PropTypes.string,
  label: PropTypes.node,
  formik: PropTypes.object,
  pathValue: PropTypes.string,
  fullWidth: PropTypes.bool,
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default FormikDatePicker;
